import { type FC } from "react";
import { Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { FilterProvider } from "@/partner/shared/components/Filter";
import { CollectionsFilter } from "./CollectionsFilter";
import { CollectionsList } from "./CollectionsList";
import { CreateCollectionDialog } from "./CreateCollectionDialog";
import { EditCollectionDialog } from "./EditCollectionDialog";

// Порт референсного Rightholder/Collections: состояние страницы целиком в
// query-параметрах (?tab=create | ?tab=edit&id=…; вложенность — фильтр
// filter[collectionIds] по родителю, breadcrumbs в референсе нет).
export const Collections: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tab = searchParams.get("tab");
  const editId = searchParams.get("id");

  const handleEdit = (id: string) => {
    searchParams.set("tab", "edit");
    searchParams.set("id", id);
    setSearchParams(searchParams);
  };

  const handleCreate = () => {
    searchParams.set("tab", "create");
    setSearchParams(searchParams);
  };

  const handleClose = () => {
    searchParams.delete("tab");
    searchParams.delete("id");
    setSearchParams(searchParams);
  };

  return (
    <FilterProvider>
      <Stack spacing={1}>
        <CollectionsFilter onCreateCollection={handleCreate} />
        <CollectionsList onEditCollection={handleEdit} />
      </Stack>

      <CreateCollectionDialog
        open={tab === "create"}
        onClose={handleClose}
        onCompleted={handleClose}
      />
      <EditCollectionDialog
        open={tab === "edit" && Boolean(editId)}
        collectionId={editId}
        onClose={handleClose}
        onCompleted={handleClose}
      />
    </FilterProvider>
  );
};
